import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection} from '@angular/fire/firestore';
import { Store } from '@ngrx/store';
import { selectLastMileCollectionName } from 'app/auth/auth.reducer';
import { LastMile, OrderParcel } from 'app/shared/shared.interfaces';
import { combineLatest, Observable, of, Subject } from 'rxjs';
import { switchMap, takeUntil } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LastMileHelperService {

  collectionName: string = '';
  unsubscribe$ = new Subject<void>();

  constructor(
    private firestore: AngularFirestore,
    private store: Store
  ) {
    this.store.select<string>(selectLastMileCollectionName)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(collectionName => {
        this.collectionName = collectionName ?? 'last-mile'
      });
  }

  getLastMileObject(lastMileId: string): Observable<LastMile> {
    const ref = this.firestore.collection<LastMile>(this.collectionName);
    return combineLatest(
      [
        this.getLastMile(ref, lastMileId),
        this.getLastMileParcels(ref, lastMileId)
      ]).pipe(
      switchMap(([lastMile, parcels]) => {
        if(parcels && !lastMile.Parcels){
          const lmParcels = Object.fromEntries(parcels.map(parcel => [parcel.ParcelWaybill, parcel]));
          lastMile.Parcels = lmParcels;
        }
        return of(lastMile);
      }));
  }

  getLastMileParcels(ref: AngularFirestoreCollection<LastMile>,lastMileId: string): Observable<OrderParcel[]>{
    return ref
      .doc(lastMileId)
      .collection<OrderParcel>('parcels')
      .valueChanges()
  }

  getLastMile(ref: AngularFirestoreCollection<LastMile>, lastMileId: string): Observable<LastMile> {
    return ref
      .doc<LastMile>(lastMileId)
      .valueChanges()
  }
}
